export default {
    admin: {
        title: "Dashboard",
        subtitle: "Vista general del sistema y gestión de cuentas",
        newAccount: "Nueva Cuenta",
        loading: "Cargando dashboard...",
        stats: {
            totalAccounts: "Total de Cuentas",
            activeAccounts: "Cuentas Activas",
            newThisMonth: "Nuevas Este Mes",
            suspendedAccounts: "Cuentas Suspendidas",
        },
        recentAccounts: {
            title: "Cuentas Recientes",
            description: "Últimas 5 cuentas creadas en el sistema",
            viewAll: "Ver todas",
            headers: {
                userType: "Tipo de Usuario",
                legalName: "Nombre Legal",
                entityType: "Tipo de Entidad",
                country: "País",
                status: "Estado",
                createdAt: "Fecha de Creación",
            },
            status: {
                active: "Activo",
                suspended: "Suspendido",
                inactive: "Inactivo",
            },
        },
    },
    sender: {
        title: "Dashboard",
        subtitle: "Vista general de contenedores y colaboraciones",
        loading: "Cargando dashboard...",
        stats: {
            totalContainers: "Total de Contenedores",
            inTransit: "En Tránsito",
            delivered: "Entregados",
            delayed: "Retrasados",
            pendingDocuments: "Documentos Pendientes",
            highRisk: "Alto Riesgo",
        },
        collaborations: {
            title: "Colaboraciones",
            total: "Total",
            active: "Activas",
            pending: "Pendientes",
        },
        team: {
            title: "Equipo",
            total: "Total",
            active: "Activos",
        },
        recentContainers: {
            title: "Contenedores Recientes",
            description: "Últimos 5 contenedores creados",
            viewAll: "Ver todos",
            headers: {
                containerId: "ID de Contenedor",
                route: "Ruta",
                progress: "Progreso",
                eta: "ETA",
                docStatus: "Estado Doc",
                riskLevel: "Nivel de Riesgo",
                value: "Valor",
            },
        },
    },
    shipper: {
        title: "Dashboard",
        subtitle: "Vista general de contenedores y colaboraciones",
        loading: "Cargando dashboard...",
        stats: {
            totalContainers: "Total de Contenedores",
            inTransit: "En Tránsito",
            delivered: "Entregados",
            delayed: "Retrasados",
            pendingDocuments: "Documentos Pendientes",
            highRisk: "Alto Riesgo",
        },
        collaborations: {
            title: "Colaboraciones",
            total: "Total",
            active: "Activas",
            pending: "Pendientes",
        },
        team: {
            title: "Equipo",
            total: "Total",
            active: "Activos",
        },
        recentContainers: {
            title: "Contenedores Recientes",
            description: "Últimos 5 contenedores creados",
            viewAll: "Ver todos",
            headers: {
                containerId: "ID de Contenedor",
                route: "Ruta",
                progress: "Progreso",
                eta: "ETA",
                docStatus: "Estado Doc",
                riskLevel: "Nivel de Riesgo",
                value: "Valor",
            },
        },
    },
    receiver: {
        title: "Dashboard",
        subtitle: "Vista general de contenedores recibidos y colaboraciones",
        loading: "Cargando dashboard...",
        newOrderRequest: "Nueva Solicitud de Pedido",
        manageShippers: "Gestionar Expedidores",
        viewContainers: "Ver Contenedores",
        newOrderModal: {
            title: "Nueva Solicitud de Pedido",
            shipper: "Expedidor",
            shipperPlaceholder: "Selecciona un expedidor",
            targetWeek: "Semana Objetivo",
            packingList: "Lista de Empaque Solicitada",
            packingListPlaceholder: "Describe en detalle la lista de empaque solicitada...",
            notes: "Notas",
            notesPlaceholder: "Notas adicionales sobre el pedido...",
            submit: "Crear Pedido"
        },
        stats: {
            totalContainers: "Total de Contenedores",
            inTransit: "En Tránsito",
            delivered: "Entregados",
            delayed: "Retrasados",
            pendingDocuments: "Documentos Pendientes",
            highRisk: "Alto Riesgo",
        },
        collaborations: {
            title: "Colaboraciones",
            total: "Total",
            active: "Activas",
            pending: "Pendientes",
        },
        team: {
            title: "Equipo",
            total: "Total",
            active: "Activos",
        },
        recentContainers: {
            title: "Contenedores Recientes",
            description: "Últimos 5 contenedores recibidos",
            viewAll: "Ver todos",
            headers: {
                containerId: "ID de Contenedor",
                shipper: "Expedidor",
                route: "Ruta",
                progress: "Progreso",
                docStatus: "Estado Doc",
                riskLevel: "Nivel de Riesgo",
            },
        },
        monthlyTrend: {
            title: "Tendencia Mensual",
        },
        trendVsLastMonth: "vs mes pasado",
        receivedContainers: "Contenedores Recibidos",
        activeShippers: "Expedidores Activos",
        charts: {
            commodityDistribution: "Distribución de Mercancías",
            originCountries: "Países de Origen",
            arrivalPorts: "Puertos de Llegada",
        },
    },
};

